import { render, staticRenderFns } from "./NavbarStatic.vue?vue&type=template&id=aeedb0d0"
import script from "./NavbarStatic.vue?vue&type=script&lang=js"
export * from "./NavbarStatic.vue?vue&type=script&lang=js"
import style0 from "./NavbarStatic.vue?vue&type=style&index=0&id=aeedb0d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports